import { Component } from '@angular/core';
import { LiveCabMapComponent } from './live-cab-map/live-cab-map.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LiveCabMapComponent],  // Import the standalone LiveCabMapComponent
  template: '<app-live-cab-map></app-live-cab-map>',  // Use the map component
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'live-cab-tracking';
}
